import { makeAutoObservable, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';
export default class BusinessStore {
	constructor() {
		makeAutoObservable(this);
		makePersistable(this, {
			name: 'BusinessStore',
			properties: [
				'business',
				'OnboardingStageOne',
				'bId',
				'businesses',
				'businessMobile',
				'defaultCurrency',
			],
		});
	}

	business = {};
	businesses = [];
	bId = '';
	OnboardingStageOne = {};
	businessMobile = '';
	defaultCurrency = '';

	setBusinessOnboardingStageOne = async state => {
		runInAction(async () => {
			this.OnboardingStageOne = state;
		});
	};

	setBusiness = async state => {
		runInAction(async () => {
			this.business = state;
		});
	};
	setBusinesses = async state => {
		runInAction(async () => {
			this.businesses = state;
		});
	};
	setBId = async state => {
		runInAction(async () => {
			this.bId = state;
		});
	};

	setBusinessMobile = async state => {
		runInAction(async () => {
			this.businessMobile = state;
		});
	};

	setDefaultCurrency = async state => {
		runInAction(async () => {
			this.defaultCurrency = state;
		});
	};

	reset = () => {
		this.business = {};
		this.OnboardingStageOne = {};
		this.bId = '';
		this.businesses = [];
		this.businessMobile = '';
		this.defaultCurrency = '';
	};
}
